import React from 'react';

import { propTypes } from './ThesaurusGroupsRootProps';

import ThesaurusGroupsList from '../ThesaurusGroupsList';

import './ThesaurusGroupsRoot.custom.scss';

function ThesaurusGroupsRoot(props) {
  const { filter, expandSearchOptions } = props;
  const thesaurusRootId = filter.get('thesaurusRootId');

  const diaplayNone = expandSearchOptions ?
    {
      display: 'none',
    } :
    {};

  return (
    <section
      style={diaplayNone}
      className='tree-view-dialog-thesaurus-root-wrapper'
    >
      <div className='tree-view-dialog-thesaurus-root'>
        <ThesaurusGroupsList
          {...props}
          identificatorOfBatchItems={thesaurusRootId}
          item={filter}
        />
      </div>
    </section>
  );
}

ThesaurusGroupsRoot.propTypes = propTypes;

export default ThesaurusGroupsRoot;
